export function setBranchOffices(state, branchOffices) {
    state.branchOffices = branchOffices;
}

export function setBranchofficeWarehouses(state, branchofficeWarehouses) {
    state.branchoffice_warehouses = branchofficeWarehouses;
}

export function setLines(state, lines){
  state.lines = lines
}

export function setBrands(state, brands){
  state.brands = brands
}

export function clearParamsBranchofficesWarehouseId(state){
  state.params.branchoffice_warehouse_id = null
}

export function setPreloader(state, preloader){
  state.preloader = preloader
}
export function setDataReport(state, data){
  state.data_report = data
}
export function setDownloadExcel(state, data){
  state.params.download = data
}



// WEBPACK FOOTER //
// ./src/modules/inventory-report-wms/mutations.js